import React from "react";

function CtaBlock(props) {
  const { title, subtitle } = props.data;
  return (
    <div className="dt-cta-section section-gap" id={props.id ? props.id : ''}>
      <div className="container">
        <div className="dt-cta-inner">
          <div className="leftbar">
            <h2>{title}</h2>
            <h3>{subtitle}</h3>
          </div>
          <div className="rightbar">
            <a className="button button-white right-arrow" href="/contact/">Get Started</a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CtaBlock;